// extracted by mini-css-extract-plugin
export default {"wrapper":"Beneficiaries_wrapper__0n9D9","ul":"Beneficiaries_ul__RhczJ","benefit":"Beneficiaries_benefit__s-c7X","img1":"Beneficiaries_img1__8hzuy","img3":"Beneficiaries_img3__I9R+N"};